import Storage from './storage.js';
import events from './event.js';
import TextParser from './textParser.js';
import Logger from './logger.js';
import products from './products.js';

class TableItemRow {
    wrapperDiv = null;
    rowDiv = null;
    options = {};
    constructor(options) {
        this.options = options;
        this.wrapperDiv = options.wrapperDiv;
        this.createRow();
        this.addListeners();
    }

    createRow() {
        const div = document.createElement('div');
        div.classList.add('mscp-item');
        div.dataset.value = this.options.term.value;
        // div.dataset.id = this.options.term.id;
        if (this.options.extraDataAttributes) {
            this.options.extraDataAttributes.forEach(attr => {
                if (this.options.term[attr] !== undefined) {
                    div.dataset[attr] = this.options.term[attr];
                }
            });
        }
        div.setAttribute('data-type', this.options.type);
        if (this.options.term.value === Storage.get(this.options.type)) {
            div.classList.add('selected');
            if (this.options.selectCallback) {
                this.options.selectCallback(div, this.options.term.value, Storage.get(this.options.type));
            }
        }
        this.rowDiv = div;

        this.createTitle();
        this.createDescription();
        this.createTags();
        this.createPrice();
    }

    createTitle() {
        const titleWrapper = document.createElement('span');
        titleWrapper.classList.add('mscp-item-title-wrapper', 'mscp-row', 'subheader-3');
        this.rowDiv.appendChild(titleWrapper);

        // If a preCreateTitleCallback is provided, call it to add custom content
        if (this.options.preCreateTitleCallback) {
            const preTitle = this.options.preCreateTitleCallback(this.options.term);
            if (preTitle) {
                titleWrapper?.appendChild(preTitle);
            }
        }
        // Create the title element
        const title = document.createElement('span');
        title.classList.add('mscp-item-title', 'mscp-column');
        title.innerHTML = this.options.term.name;
        titleWrapper?.appendChild(title);

        // If a postCreateTitleCallback is provided, call it to add custom content
        if (this.options.postCreateTitleCallback) {
            const postTitle = this.options.postCreateTitleCallback(this.options.term);
            // check if postTitle is a promise
            if (postTitle instanceof Promise) {
                postTitle.then(result => {
                    if (Array.isArray(result)) {
                        result.forEach(el => {
                            titleWrapper?.appendChild(el);
                        });
                    } else if (result) {
                        titleWrapper?.appendChild(result);
                    }
                });
            } else if (postTitle instanceof HTMLElement) {
                titleWrapper.appendChild(postTitle);
            }
        }
    }
    createDescription() {
        if (this.options.overrideDescription) {
            const overriddenDescription = this.options.overrideDescription(this.options.term);
            if (overriddenDescription) {
                this.rowDiv.appendChild(overriddenDescription);
                return;
            }
        }
        if (this.options.term.description) {
            const description = document.createElement('span');
            description.classList.add('mscp-item-description', 'mscp-row');
            // description.innerHTML = this.createDescriptionWithAdditionalLink(this.options.term.description);
            description.innerHTML = this.options.term.description;
            TextParser.link(description, (attrs) => {
                const type = (this.options.type == 'uploadPaper') ? 'paper' : this.options.type;
                const propName = type + '_info_text';
                events.trigger('openAdditionalInfoPopup', {
                    text_prop_name: propName,
                });
                return false; // Prevent default link behavior
            });
            this.rowDiv.appendChild(description);
        }
    }

    createTags() {
        const allTags = window.mscp?.tags || [];
        const termSlug = String(this.options.term.value ?? '');
        const tableType = this.options.type ?? '';

        const matching = allTags.filter(tag =>
            tag.table === tableType &&
            (tag.term_slug === '' || tag.term_slug === termSlug)
        );

        if (matching.length === 0) return;

        const wrapper = document.createElement('div');
        wrapper.classList.add('mscp-item-tags');

        matching.forEach(tag => {
            const labels = tag.label.split(',').map(s => s.trim()).filter(Boolean);
            labels.forEach(label => {
                const span = document.createElement('span');
                span.classList.add('mscp-item-tag');
                span.textContent = label;
                span.style.backgroundColor = tag.bg;
                span.style.color = tag.color;
                wrapper.appendChild(span);
            });
        });

        this.rowDiv.appendChild(wrapper);
    }

    createPrice() {
        // const price = document.createElement('span');
        // price.classList.add('mscp-item-price', 'mscp-column');
        // price.innerHTML = this.options.term.price;
        // this.rowDiv.appendChild(price);
    }

    addListeners() {
        this.rowDiv.addEventListener('click', async (e) => {
            e.stopPropagation();

            // Stäng menyn om den är öppen
            events.trigger('closeMainMenu');

            // if not class mscp-item, get parent
            const el = (e.target.classList.contains('mscp-item')) ? e.target : e.target.closest('.mscp-item');

            if (this.options?.selectRule) {
                // If selectRule is defined, check if the item can be selected
                const canSelect = await this.options.selectRule(el);
                if (!canSelect) {
                    Logger.debug("Item cannot be selected based on selectRule");
                    return;
                }
            }

            const value = el.getAttribute('data-value');
            const type = el.getAttribute('data-type');

            // clear if not value valid with current selections
            const isValid = await products.clearIfNotValidCombination(type, value);
            if (!isValid) {
                Logger.warn(`Value %s is not valid with the current selections.`, value);
                return;
            }

            const selected = this.wrapperDiv.querySelectorAll('.mscp-item.selected');
            selected?.forEach((sel) => {
                sel.classList.remove('selected');
            });

            // add selected class to the clicked item and save the value in storage
            const oldValue = Storage.get(this.options.type);
            el.classList.add('selected');
            if (oldValue !== value) {
                Storage.save(this.options.type, value);
            }

            Logger.debug('Selected term:', value);

            if (this.options.selectCallback) {
                this.options.selectCallback(el, value, oldValue);
            }

            events.trigger('updateNavigation'); // Trigger navigation update
        });
    }
}
export default TableItemRow;
